import React, { useEffect, useState } from 'react';
import 'date-fns';
import {
  Backdrop,
  CircularProgress,
  CardContent,
  Container,
  Card,
  Divider,
  Grid,
  TextField,
  TableCell,
  TableBody,
  TableRow,
  TableContainer,
  Table,
  TableHead,
  createMuiTheme,
  Button,
  Snackbar,
  Breadcrumbs,
  Link,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  CardHeader,
} from '@material-ui/core';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { makeStyles, ThemeProvider } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';
import Page from 'src/components/Page';
import { getUser } from 'src/utils/Common';
import SaveIcon from '@material-ui/icons/Save';
import axios from 'src/utils/axios';
import trLocale from "date-fns/locale/tr";
import moment from 'moment';
import 'react-confirm-alert/src/react-confirm-alert.css';
import Alert from 'src/components/Alert';
import { sc } from 'src/utils/Common';
import SearchBar from 'material-ui-search-bar';
import PublishIcon from '@material-ui/icons/Publish';
import FileUpload from 'src/components/FileUpload';
import ServiceFileUpload from 'src/components/ServiceFileUpload'
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/CloseOutlined';
import AlertYasal from '@material-ui/lab/Alert';
import EditIcon from '@material-ui/icons/Edit';
import AttachmentIcon from '@material-ui/icons/Attachment';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    minWidth: 275,
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(3)
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: '25ch',
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },

  cardscontent: {
    minHeight: 550
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: 'rotate(180deg)'
  },
  cardsMax: {
    // maxHeight: 230,
    minHeight: 230
  },
  cardsContentMax: {
    // maxHeight: 180,
    minHeight: 180
  },
  cards: {
    minHeight: 350
    // maxHeight: 500,
  },
  container: {
    maxHeight: 500
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
}));
const siyah = '#424242';
const materialTheme = createMuiTheme({
  palette: {
    primary: {
      contrastText: '#FFFFFF',
      dark: siyah,
      main: siyah,
      light: siyah
    }
  }
});
const localeMap = {
  tr: trLocale,
};



function FleetCostManagement() {
  const { t } = useTranslation('Technician_Management');
  const classes = useStyles();
  const locale = localStorage.getItem('i18nextLng');
  const SessionUser = getUser();
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: t('success_message1')
  });

  const [Required, setRequired] = useState(false);
  const [loading, setLoading] = useState(false);
  const [FleetData, setFleetData] = useState([]);
  const [searched, setSearched] = useState('');
  const [initialResult, setInitialResult] = useState({});


  const [UploadDate, setUploadDate] = useState(moment());
  const [RegistrationNumber, setRegistrationNumber] = useState(null)
  const [Odometer, setOdometer] = useState(null)
  const [ServiceComment, setServiceComment] = useState(null)

  const [FileDialog, setFileDialog] = useState(false)
  const [FileList, setFileList] = useState([])
  const [EditFileList, setEditFileList] = useState([])

  const [RequiredFieldsAlert, setRequiredFieldsAlert] = useState(false)
  const [uyariTip, setUyariTip] = React.useState('error');
  const [AlertMessage, setAlertMessage] = React.useState('Deneme')

  const defaultServiceInfo = {
    service: SessionUser.ServiceShopName,
    ServiceShopId: SessionUser.ServiceShopId
  };
  const [serviceShop, setServiceShop] = useState(defaultServiceInfo);
  const [SelectedFleet, setSelectedFleet] = useState({})
  const [EditFleetPopup, setEditFleetPopup] = useState(false)
  const [UpdateFileDialog, setUpdateFileDialog] = useState(false)

  const changeUploadDate = e => {
    setUploadDate(e);
  };

  useEffect(() => {
    getFleetListData();
  }, [locale]);


  async function getFleetListData() {
    setLoading(true)
    axios
      .get(`/GetFleetList/${SessionUser.ServiceShopId}`)
      .then(response => {
        const Response = response.data;
        if (Response.length > -1) {
          setFleetData(Response);
          setInitialResult(Response);
        } else {
          setFleetData([]);
        }
        setLoading(false);
      })
      .catch(error => {
        setFleetData([]);
        setLoading(false);
      });
  };

  const requestSearch = (searchedVal) => {
    const filteredRows = initialResult.filter((item) => sc(
      item.RegistrationNumber,
      searchedVal
    ));
    setFleetData(filteredRows);

  };

  const cancelSearch = () => {
    setSearched('');
    requestSearch(searched);
  };

  function closeFileUpload(files) {
    setFileList(files)
    setFileDialog(false)
  }

  async function saveNewFleet() {
    const data = {
      Id: 0,
      StatusId: 1,
      ServiceshopId: SessionUser?.ServiceShopId,
      UploadDate: moment(UploadDate).format('MM-DD-YYYY'),
      RegistrationNumber: RegistrationNumber,
      ServiceShopComment: ServiceComment,
      HqComment: "",
      Odometer: Odometer,
      Fuel: 0,
      FuelLiter: 0,
      NetRental: 0,
      OtherTransportPrice: 0,
      FileStreamData: "",
      CreateEmployeeId: SessionUser?.TechnicianId,
      UpdateEmployeeId: 0
    }
    const config = {
      headers: { 'Content-Type': 'application/json' }
    }

    if (UploadDate && RegistrationNumber && Odometer && ServiceComment && FileList.length > 0) {
      setLoading(true)
      axios
        .post('/UpdateFleetList', data, config)
        .then(response => {
          if (response.data.ErrorCode === "200") {
            getFleetListData()
            saveFleetFile(parseInt(response.data.ErrorDescription))
            setUyariTip('success')
            setAlertMessage(t('lblSuccess'))
            setRequiredFieldsAlert(true)
          }
          else {
            setUyariTip('error')
            setAlertMessage(response.data.ErrorDescription)
            setRequiredFieldsAlert(true)
          }
          setLoading(false)
        })
        .catch(error => {
          setLoading(false)
        });
    }
    else {
      setUyariTip('error')
      setAlertMessage(t('lblFleetSaveError'))
      setRequiredFieldsAlert(true)
    }
  }

  async function saveFleetFile(fleetId) {
    const config = {
      headers: { 'Content-Type': 'application/json' }
    }
    const data = {
      FleetId: fleetId,
      FleetFileList: FileList
    }

    axios
      .post('/SaveFleetFiles', data, config)
      .then(response => {

      })
      .catch(error => {
      });

  }

  function deleteFile(file) {
    const tmpListData = [...FileList];
    const index = tmpListData.findIndex(x => x.MIMEType === file.MIMEType && x.Title === file.Title);
    tmpListData.splice(index, 1);
    setFileList(tmpListData);
  }

  function editDeleteFile(file) {
    const tmpListData = [...EditFileList];
    const index = tmpListData.findIndex(x => x.MIMEType === file.MIMEType && x.Title === file.Title);
    tmpListData.splice(index, 1);
    setEditFileList(tmpListData);
  }

  function openFleetEditPopup(fleet) {
    if (fleet.StatusId === 3) {
      setSelectedFleet(fleet)
      setEditFleetPopup(true)
    }
  }

  function openFileDialog() {
    setLoading(true)
    axios
      .get(`/GetFleetFiles/${SelectedFleet.Id}`)
      .then(response => {
        setEditFileList(response.data)
        setLoading(false);
        console.log(response.data)
        setUpdateFileDialog(true)
      })
      .catch(error => {
        setLoading(false);
      });
  }

  function updateFleet() {
    const data = {
      Id: SelectedFleet.Id,
      UploadDate: SelectedFleet.UploadDate,
      RegistrationNumber: SelectedFleet.RegistrationNumber,
      Odometer: SelectedFleet.Odometer,
      ServiceShopComment: SelectedFleet.ServiceShopComment
    }
    console.log(data)
    const config = {
      headers: { 'Content-Type': 'application/json' }
    }
    if ((data.UploadDate != null || data.UploadDate != undefined)
      && (data.RegistrationNumber != null || data.RegistrationNumber != undefined)
      && (data.Odometer != null || data.Odometer != undefined)
      && (data.ServiceShopComment != null || data.ServiceShopComment != undefined)) {
      setLoading(true)
      axios
        .post('/UpdateFleetByService', data, config)
        .then(response => {
          if (response.data.ErrorCode === "413" || response.data.ErrorCode === "400") {
            setUyariTip('error')
            setAlertMessage(response.data.ErrorDescription)
            setRequiredFieldsAlert(true)
          }
          else {
            setUyariTip('success')
            setAlertMessage(t('lblSuccess'))
            setRequiredFieldsAlert(true)
            setEditFleetPopup(false)
            getFleetListData(SessionUser?.ServiceShopId)
          }
          setLoading(false)
        })
        .catch(error => {
          setLoading(false)
        });
    }
    else {
      setUyariTip('error')
      setAlertMessage(t('lblFleetSaveError'))
      setRequiredFieldsAlert(true)
    }

  }

  function closeFileUploadForServiceUpdate(files){
    const config = {
      headers: { 'Content-Type': 'application/json' }
    }
    const data = {
      FleetId: SelectedFleet.Id,
      FleetFileList: files
    }
    setLoading(true)
    setUpdateFileDialog(false)
    axios.post('/DeleteFleetFiles',data,config).then(x => {
      axios.post('/SaveFleetFiles', data, config).then(response => {
        setLoading(false)
        setEditFleetPopup(true)
      })
      .catch(error => {

      });
    })
    

  }

  return (
    <Page title="">
      <Container maxWidth="xl" spacing={1}>
        <Breadcrumbs >
          <Link color="inherit">Sirius</Link>
          <Typography color="textPrimary">{t('lblFleetCostManagement')}</Typography>
        </Breadcrumbs>
        <Divider />
        <Card>
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={4} lg={12}>
                <TextField
                  disabled
                  size="small"
                  id="service"
                  autoComplete="no"
                  value={serviceShop.service}
                  onChange={event =>
                    setServiceShop({
                      ...serviceShop,
                      service: event.target.value
                    })}
                  fullWidth
                  label={t('lblServiceShop')}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} sm={4} lg={12}>
                <ThemeProvider theme={materialTheme}>
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    locale={localeMap[locale]}
                  >
                    <KeyboardDatePicker
                      color="primary"
                      inputVariant="outlined"
                      id="orderDate"
                      size="small"
                      disablePast
                      invalidDateMessage={t('hatali_tarih')}
                      format="dd.MM.yyyy"
                      fullWidth
                      label={t('lblUploadDate')}
                      variant="outlined"
                      value={UploadDate}
                      onChange={e => changeUploadDate(e)}
                      KeyboardButtonProps={{
                        'aria-label': 'change date'
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </ThemeProvider>
              </Grid>
              <Grid item xs={12} sm={4} lg={12}>
                <TextField
                  size="small"
                  id="service"
                  autoComplete="no"
                  value={RegistrationNumber}
                  onChange={event =>
                    setRegistrationNumber(event.target.value)}
                  fullWidth
                  label={t('lblRegistrationNumber')}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} sm={4} lg={12}>
                <TextField
                  size="small"
                  id="service"
                  autoComplete="no"
                  type="number"
                  value={Odometer}
                  onChange={event =>
                    setOdometer(event.target.value)}
                  fullWidth
                  label={t('lblOdometer')}
                  variant="outlined"
                />
              </Grid>

              <Grid item xs={12} sm={12} lg={12}>
                <TextField
                  size="small"
                  id="Description"
                  multiline
                  rows={3}
                  autoComplete="no"
                  fullWidth
                  error={ServiceComment?.length > 0 ? false : Required}
                  label={t('lblServiceComment')}
                  variant="outlined"
                  value={ServiceComment}
                  onChange={(event) => setServiceComment(
                    event.target.value
                  )}
                />
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={3} lg={12}></Grid>
              <Grid item xs={12} sm={3} lg={12}>
                <Button
                  align={"right"}
                  variant="contained"
                  color="primary"
                  size="small"
                  fullWidth
                  onClick={() => setFileDialog(true)}
                  endIcon={<PublishIcon />}
                >
                  {t('lblUpload')}
                </Button>
              </Grid>
              <Grid item xs={12} sm={3} lg={12}>
                <Button
                  align={"right"}
                  variant="contained"
                  color="primary"
                  size="small"
                  fullWidth
                  onClick={() => saveNewFleet()}
                  endIcon={<SaveIcon />}
                >
                  {t('lblSave')}
                </Button>
              </Grid>
            </Grid>

            {
              FileList.length < 1 ?
                <>
                  <br></br>
                  <br></br>
                  <AlertYasal severity="warning">{t('lblFileErrorDesc')
                    + ' ' + t('lblCurrenltyFileHave') + FileList.length} </AlertYasal>
                </>
                :
                null
            }

          </CardContent>
          <Divider />
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={4} sm={4} lg={3} />
              <Grid item xs={4} sm={4} lg={6}>
                <SearchBar
                  inputSizeSmall
                  value={searched}
                  onChange={searchVal => requestSearch(searchVal)}
                  onCancelSearch={() => cancelSearch()}
                  placeholder={t('lblSearch')}
                // style={{ margin: '0 auto', maxWidth: 800, maxHeight: 37 }}
                />
              </Grid>
              <Grid item xs={4} sm={4} lg={3} />
            </Grid>
            <Container maxWidth="xl" spacing={1}>
              < br />
              <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table" size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell align="left">
                        {t('lblFleetId')}
                      </TableCell>
                      <TableCell align="left">
                        {t('lblStatus')}
                      </TableCell>
                      <TableCell align="left">
                        {t('lblUploadDate')}
                      </TableCell>
                      <TableCell align="left">
                        {t('lblServiceName')}
                      </TableCell>
                      <TableCell align="left">
                        {t('lblRegistrationNumber')}
                      </TableCell>
                      <TableCell align="left">
                        {t('lblServiceComment')}
                      </TableCell>
                      <TableCell align="left">
                        {t('lblHqComment')}
                      </TableCell>
                      <TableCell align="left">
                        {t('lblOdometer')}
                      </TableCell>
                      <TableCell align="left">
                        {t('lblFuel')}
                      </TableCell>
                      <TableCell align="left">
                        {t('lblRental')}
                      </TableCell>
                      <TableCell align="left">
                        {t('lblOtherTransportPrice')}
                      </TableCell>
                      <TableCell align="left">
                        {t('lblFinalTotal')}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {FleetData?.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell align="left">{row.Id}</TableCell>
                        <TableCell align="left">
                          <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            fullWidth
                            onClick={() => openFleetEditPopup(row)}
                            style={row.StatusId === 1 ? { backgroundColor: '#f2e724' } :
                              row.StatusId === 2 ? { backgroundColor: '#13d426' } :
                                row.StatusId === 3 ? { backgroundColor: '#e00942' } :
                                  {}}
                            endIcon={row.StatusId === 3 ? <EditIcon /> : null}
                          >{row.Status}
                          </Button>
                        </TableCell>
                        <TableCell align="left">{moment(row.UploadDate).format('DD-MM-YYYY')}</TableCell>
                        <TableCell align="left">{row.ServiceShopName}</TableCell>
                        <TableCell align="left">{row.RegistrationNumber}</TableCell>
                        <TableCell align="left">{row.ServiceShopComment}</TableCell>
                        <TableCell align="left">{row.HqComment}</TableCell>
                        <TableCell align="left">{row.Odometer}</TableCell>
                        <TableCell align="left">{row.Fuel}</TableCell>
                        <TableCell align="left">{row.NetRental}</TableCell>
                        <TableCell align="left">{row.OtherTransportPrice}</TableCell>
                        <TableCell align="left">{row.Fuel + row.NetRental + row.OtherTransportPrice}</TableCell>

                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Container>
          </CardContent>
        </Card>
      </Container>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Dialog
        open={FileDialog}
        maxWidth="lg"
        onClose={event => setFileDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{t('lblFileUpload')}</DialogTitle>
        <DialogContent>
          <FileUpload onClose={closeFileUpload} fileList={FileList} deleteFile={deleteFile} />
        </DialogContent>
        <DialogActions>
          <IconButton
            color="primary"
            onClick={event => setFileDialog(false)}
            aria-label="upload picture"
            component="span"
          >
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </Dialog>
      <Dialog
        open={EditFleetPopup}
        fullWidth
        maxWidth="sm"
        onClose={() => setEditFleetPopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Backdrop className={classes.backdrop} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <DialogTitle id="customized-dialog-title" onClose={() => setEditFleetPopup(false)}>
          {t('lblEditFleet')}
        </DialogTitle>
        <Container maxWidth="xl" spacing={1}>

          <Divider />
          <Card>
            <CardHeader title={`${t('lblFleetId')}: ${SelectedFleet.Id}`} />
            <Divider />
            <CardContent>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12} lg={12}>
                  <ThemeProvider theme={materialTheme}>
                    <MuiPickersUtilsProvider
                      utils={DateFnsUtils}
                      locale={localeMap[locale]}
                    >
                      <KeyboardDatePicker
                        color="primary"
                        inputVariant="outlined"
                        id="orderDate"
                        size="small"
                        invalidDateMessage={t('hatali_tarih')}
                        format="dd.MM.yyyy"
                        fullWidth
                        label={t('lblUploadDate')}
                        variant="outlined"
                        value={SelectedFleet.UploadDate}
                        onChange={(e) => setSelectedFleet({ ...SelectedFleet, UploadDate: e })}
                        KeyboardButtonProps={{
                          'aria-label': 'change date'
                        }}
                      />
                    </MuiPickersUtilsProvider>
                  </ThemeProvider>
                </Grid>
                <Grid item xs={12} sm={12} lg={12}>
                  <TextField
                    size="small"
                    id="service"
                    autoComplete="no"
                    value={SelectedFleet.RegistrationNumber}
                    onChange={(event) => setSelectedFleet({ ...SelectedFleet, RegistrationNumber: event.target.value })}
                    fullWidth
                    label={t('lblRegistrationNumber')}
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12} sm={12} lg={12}>
                  <TextField
                    type="number"
                    size="small"
                    id="service"
                    autoComplete="no"
                    value={SelectedFleet.Odometer}
                    onChange={(event) => setSelectedFleet({ ...SelectedFleet, Odometer: event.target.value })}
                    fullWidth
                    label={t('lblOdometer')}
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12} sm={12} lg={12}>
                  <TextField
                    size="small"
                    id="Description"
                    multiline
                    rows={3}
                    autoComplete="no"
                    fullWidth
                    error={SelectedFleet.ServiceShopComment?.length > 0 ? false : Required}
                    label={t('lblServiceComment')}
                    variant="outlined"
                    value={SelectedFleet.ServiceShopComment}
                    onChange={(event) => setSelectedFleet({ ...SelectedFleet, ServiceShopComment: event.target.value })}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
          <Divider />
        </Container>
        <DialogActions>
          <Button
            color="primary"
            onClick={() => openFileDialog()}
            aria-label="save"
            component="span"
            variant="contained"
            endIcon={<AttachmentIcon />}
          >
            {t('lblAttachment')}
          </Button>
          <Button
            color="primary"
            onClick={() => updateFleet()}
            aria-label="save"
            component="span"
            variant="contained"
            //endIcon={<ThumbUpIcon />}
            style={{ backgroundColor: '#f2e724' }}
          >
            {t('lblUpdateToWaiting')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={UpdateFileDialog}
        maxWidth="lg"
        onClose={event => setUpdateFileDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{t('lblFileUpload')}</DialogTitle>
        <DialogContent>
          <ServiceFileUpload onClose={closeFileUploadForServiceUpdate} fileList={EditFileList} deleteFile={editDeleteFile} />
        </DialogContent>
        <DialogActions>
          <IconButton
            color="primary"
            onClick={event => setUpdateFileDialog(false)}
            aria-label="upload picture"
            component="span"
          >
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </Dialog>
      <Snackbar open={RequiredFieldsAlert} autoHideDuration={10000} onClose={() => setRequiredFieldsAlert(false)}>
        <Alert
          onClose={() => setRequiredFieldsAlert(false)}
          message={AlertMessage}
          variant={uyariTip}
        />
      </Snackbar>
    </Page>
  );
}
export default FleetCostManagement
